// list of breakpoints is passed from scss in body::before
// current breakpoint can be read in body::after
// src : https://www.lullabot.com/articles/importing-css-breakpoints-into-javascript

/**
 * Get the current breakpoint string ('xs', 'sm', 'xl' etc.)
 * @returns {string} the current bp string
 */
export function getCurrentBreakpoint() {
    return window.getComputedStyle(document.body, ':after').content.replace(/["']/g, '');
}

/**
 * Return an Array of Objects describing the website breakpoints
 * @returns {array} of {name: 'xs', minWidth: 0 || '768px'}
 */
export function initBreakpoints() {
    const breakpointString = window.getComputedStyle(document.body, ':before').content.replace(/["']/g, '');
    const breakpointArray = breakpointString.split('|');
    const breakpointArrayOfObjects = breakpointArray.map(function (arrayString) {
        const splitString = arrayString.split(':');
        return { name: splitString[0], minWidth: splitString[1] };
    });
    return breakpointArrayOfObjects;
}

/**
 * Check if the current bp is at least the one provided as parameter (can be greater)
 * @param {*} breakpointString 'sm' / 'xs' etc.
 * @returns {boolean} true is the current breakpoint
 */
export function isAtLeast(breakpointString) {
    const currentBreakpoint = getCurrentBreakpoint();
    if (typeof window.breakpoints === 'undefined') {
        window.breakpoints = initBreakpoints();
    }
    // get the index of current Breakpoint
    let i = 0;
    for (const breakpoint of window.breakpoints) {
        if (breakpoint.name === currentBreakpoint) {
            break;
        }
        i++;
    }
    let j = 0;
    // get the index of asked breakpoint
    for (const breakpoint of window.breakpoints) {
        if (breakpoint.name === breakpointString) {
            break;
        }
        j++;
    }
    return i >= j;
}

/**
 * Get a breakpoint object
 * @param {string} breakpointString Breakpoint string like 'xs', 'sm', 'md', 'lg' or 'xl'
 * @return {[Object]} Return a breakpoint object if breakpoint exists
 */
export function getBreakpoint(breakpointString) {
    if (typeof window.breakpoints === 'undefined') {
        window.breakpoints = initBreakpoints();
    }
    return window.breakpoints.find((bp) => bp.name === breakpointString);
}

/**
 * Create a MediaQueryList object from a given breakpoint
 * @param {string} breakpointString Breakpoint string like 'xs', 'sm', 'md', 'lg' or 'xl'
 * @return {MediaQueryList} A MQL object matching the breakpoint property
 */
export function createMediaQueryList(breakpointString) {
    const breakpoint = getBreakpoint(breakpointString);
    if (!breakpoint) {
        throw new Error(`createMediaQueryList: Unknown breakpoint "${breakpointString}"`);
    }
    return window.matchMedia(`screen and (min-width: ${breakpoint.minWidth})`);
}
